import { TranslationLoadError } from '@/components/error/translation-load-error'

import i18n, { resetFailedNamespaces } from '..'
import type { Namespace } from '../namespaces'

export async function preloadNamespaces(namespaces: Namespace[]) {
  const retry = resetFailedNamespaces(namespaces)
  const pending = namespaces.filter(
    (namespace) =>
      retry.includes(namespace) || !i18n.hasLoadedNamespace(namespace),
  )

  if (pending.length === 0) {
    return
  }

  await new Promise<void>((resolve, reject) => {
    i18n.loadNamespaces(pending, (error) => {
      if (error) {
        const reason = Array.isArray(error) ? error.join('; ') : String(error)

        reject(new Error(`failed to load ${pending.join(', ')}: ${reason}`))

        return
      }

      resolve()
    })
  })
}

export function withNamespaces<Route>(
  namespaces: Namespace[],
  lazyRoute: () => Promise<Route>,
) {
  return async (): Promise<Route> => {
    try {
      await preloadNamespaces(namespaces)
    } catch (error) {
      console.error('[i18n] failed to load route namespaces', namespaces, error)

      return { Component: TranslationLoadError } as Route
    }

    return lazyRoute()
  }
}

export function namespacesLoader(namespaces: Namespace[]) {
  return async () => {
    try {
      await preloadNamespaces(namespaces)
    } catch (error) {
      console.error(
        '[i18n] failed to load branch namespaces',
        namespaces,
        error,
      )
    }

    return null
  }
}
